import React from 'react';

import Head from 'next/head';

import { applicationSettings } from '@/constants';
import { prettifyCity } from '@/helpers/helpers';
import Footer from '@/components/Footer';
import Header from '@/components/Header';
import Hero from '@/components/Hero';
import HowItWorks from '@/components/HowItWorks';
import PopularCategoriesByCity from '@/components/PopularCategoriesByCity';
import PopularCategoriesStatic from '@/components/PopularCategoriesStatic';
import PriceGuideLinks from '@/components/PriceGuideLinks';
// import Testimonials from '@/components/Testimonials'
import WhoWeAre from '@/components/WhoWeAre';

const { CALLAPRO_WEBSITE_URL } = applicationSettings;

export async function getServerSideProps(context) {
  return {
    props: {
      state: context.params.state,
      city: context.params.city
    }
  };
}

const City = (props) => {
  React.useEffect(() => {
    const geo = {
      location: `${prettifyCity(props.city)}, ${props.state.toUpperCase()}`,
      city: prettifyCity(props.city),
      region_code: props.state.toUpperCase(),
      zip_code: '',
      version: '2.0'
    };
    localStorage.setItem('geoInfo', JSON.stringify(geo));
  }, [props.city, props.state]);

  return (
    <div className="page-wrapper">
      <Head>
        <meta name="description" content={`CallAPro - Find a Home Service Professional in ${props.city}, ${props.state.toUpperCase()}`} />
        <title>
          Search Home Service Professionals in ${props.city}, ${props.state.toUpperCase()}
        </title>
        <link rel="canonical" href={`${CALLAPRO_WEBSITE_URL}/us/${props.state.toLowerCase()}/${props.city.toLowerCase()}/`} />
      </Head>
      <Header />
      <Hero />
      <PopularCategoriesByCity {...props} />
      <WhoWeAre />
      <HowItWorks />
      <PriceGuideLinks />
      <PopularCategoriesStatic />
      {/*<Testimonials />*/}
      <Footer />
    </div>
  );
};
export default City;
